/**
 * The following is only relevant if your using the internal Fetch package.
 *
 *
 * Support for query parameters by object
 *
 * NOTE: The Fetch package will complain if you try to add query params manually
 * using the url.
 *
 * Incorrect: Fetch('api/user/search?displayLabel='aircraft') < Error
 * Correct: Fetch('api/user/search',{params:{displayLabel:'aircraft'}})
 *
 * FOR MOST URLS USE createProxiedURL
 * look at middleware/express/OpenidConnect.js for the route listenting logic that auto attaches keycloak authentication for api requests
 *
 * FOR GIS MANAGER URLS createGISURL
 * look at middleware/express/GISManager.js for the route listening logic that auto attaches keycloak authetication for gis manager requests.
 *
 * When using createProxedURL you can hit 'external' or 'internal' urls without worrying about Same Origin Policy
 * https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
 */

import { createProxiedURL } from "@@/utils/EnvUtils";

const BASE_URL = window.apiHostName;
const API_GATEWAY = window.location.hostname.indexOf("localhost")>=0 ? 'http://localhost:8080/incidentcounts' : 'http://incidentcounts:8080/incidentcounts';


export const INCIDENT_URL = (params)=>{

    const finalParams = {
        ...params
    }

    return createProxiedURL(
        `${API_GATEWAY}`,
        undefined,
        finalParams
    )
}
// Example
// export const INCIDENTS_URL_FILTERED = (params) => {
//     const finalParams = {
//         size: 999,
//         sort: "lastEntityUpdate,desc",
//         //lastEntityUpdate: FIRST_DAY_OF_YEAR_DATE.getTime(),
//         ...params,
//     };

//     return createProxiedURL(
//         `${BASE_URL}/incident-api/v1/incidents/search/initializeCache`,
//         undefined,
//         finalParams
//     );
// };



